import React from 'react';

export function AgentDataColumnFormatter(agentID, agentFullName) {

  return (
    <>
      <div className="text-dark-75 font-weight-bolder font-size-lg text-nowrap">
        {agentID}
      </div>
      <div className="text-dark-75 font-weight-bolder font-size-lg text-nowrap">
        {agentFullName}
      </div>
    </>
  );
}
